import * as actionTypes from './actionTypes';
//----------------------------------------------------------------------------------------------------------------------
export const fetchList = ()=>({
        type: actionTypes.FETCH_LIST
    });
export const fetchListSuccess = (notifications)=>({
        type: actionTypes.FETCH_LIST_SUCCESS,
        payload: {
            notifications
        }
    });
export const fetchListError = (error)=>({
        type: actionTypes.FETCH_LIST_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const addNewNotification = (notification)=>({
        type: actionTypes.ADD_NEW_NOTIFICATION,
        payload: {
            notification
        }
    });
//----------------------------------------------------------------------------------------------------------------------
export const dismissNotification = (notification)=>({
        type: actionTypes.DISMISS_NOTIFICATION,
        payload: {
            notification
        }
    });
export const dismissNotificationSuccess = (notification)=>({
        type: actionTypes.DISMISS_NOTIFICATION_SUCCESS,
        payload: {
            notification
        }
    });
export const dismissNotificationError = (error, notification)=>({
        type: actionTypes.DISMISS_NOTIFICATION_ERROR,
        payload: {
            notification
        },
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const dismissFilteredNotification = ()=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS
    });
export const dismissFilteredNotificationSuccess = ()=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS_SUCCESS
    });
export const dismissFilteredNotificationCancel = ()=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS_CANCEL
    });
export const dismissFilteredNotificationOpenConfirmation = ()=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS_OPEN_CONFIRMATION
    });
export const dismissFilteredNotificationConfirm = ()=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS_CONFIRM
    });
export const dismissFilteredNotificationError = (error)=>({
        type: actionTypes.DISMISS_FILTERED_NOTIFICATIONS_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const markNotificationsRead = ()=>({
        type: actionTypes.MARK_NOTIFICATIONS_READ
    });
export const markNotificationsReadSuccess = ()=>({
        type: actionTypes.MARK_NOTIFICATIONS_READ_SUCCESS
    });
export const markNotificationsReadError = (error)=>({
        type: actionTypes.MARK_NOTIFICATIONS_READ_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const sendClinicPatientNewReadingsAddedNotification = ({ clinicId, hcpProfileId, patientFirstName, patientLastName, localPatientProfileId, readingsCount } = {})=>({
        type: actionTypes.SEND_CLINIC_PATIENT_NEW_READINGS_ADDED_NOTIFICATION,
        payload: {
            clinicId,
            hcpProfileId,
            patientFirstName,
            patientLastName,
            localPatientProfileId,
            readingsCount
        }
    });
export const sendNotificationSuccess = ()=>({
        type: actionTypes.SEND_NOTIFICATION_SUCCESS
    });
export const sendNotificationError = (error)=>({
        type: actionTypes.SEND_NOTIFICATION_ERROR,
        error
    });
//----------------------------------------------------------------------------------------------------------------------
export const setNotificationFilterParams = (notificationsFilterParams)=>({
        type: actionTypes.SET_NOTIFICATIONS_FILTER_PARAMS,
        payload: {
            notificationsFilterParams
        }
    }); //----------------------------------------------------------------------------------------------------------------------
